export { CompetitionModule } from './CompetitionModule';
export { getCompetitionDisplay } from './competitionModule.utils';
